import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    EventEmitter,
    HostBinding,
    Input,
    OnInit,
    QueryList,
    ViewChild,
} from "@angular/core";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

import { SpsTableCellComponent } from "../table-cell/sps-table-cell.component";

@Component({
    selector: "sps-table-row, sps-tr",
    templateUrl: "./sps-table-row.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsTableRowComponent implements OnInit {
    static readonly displayName = "sps-table-row / sps-tr";
    static readonly props = {
        selectable: "boolean",
    };

    private static _idNum = 0;
    _checkboxId: string;

    @HostBinding("attr.role") readonly _roleAttr = "row";
    @HostBinding("class.sps-table__row") readonly _spsTableRowClass = true;

    @Input() id: string;

    @Input() @AttributePresenceInput() selectable: boolean;

    @HostBinding("class.sps-table__row--selected")
    selected = false;
    selectedChange = new EventEmitter<boolean>();

    @ViewChild(SpsTableCellComponent, { static: false }) selectionCell: SpsTableCellComponent;
    @ContentChildren(SpsTableCellComponent) contentCells: QueryList<SpsTableCellComponent>;

    shiftClick = new EventEmitter<void>();

    constructor(private _changeDetector: ChangeDetectorRef) {}

    ngOnInit() {
        this.id = this.id || `sps-tr-${SpsTableRowComponent._idNum++}`;
        this._checkboxId = `${this.id}-checkbox`;
    }

    getCells() {
        return [ this.selectionCell, ...(this.contentCells as any as Iterable<SpsTableCellComponent>) ];
    }

    select(selectionState: boolean) {
        this.selected = selectionState;
        this._changeDetector.markForCheck();
    }

    _makeSelectable() {
        setTimeout(() => {
            this.selectable = true;
            this._changeDetector.markForCheck();
        }, 0);
    }

    _onCheckboxChange() {
        this.selectedChange.emit(this.selected);
    }

    _onCheckboxMousedown(event: MouseEvent) {
        if (event.shiftKey) {
            event.preventDefault();
        }
    }

    _onCheckboxClick(event: MouseEvent) {
        if (event.shiftKey) {
            event.preventDefault();
            document.getSelection().removeAllRanges();
            this.shiftClick.emit();
        }
    }
}
